/** Lit/Unlit runtime and review identities. Normal selection requires approved registry hydration. */
type LightSourceMesh = { id: string; key: string; label: string; state: 'lit' | 'unlit'; itemId: string; boundsM: [number, number, number]; runtime: { kind: 'glb'; url: string; sha256: string; bytes: number } };
export const LIGHT_SOURCE_MESHES: LightSourceMesh[] = [
  {
    "id": "FA743BA1-F1C8-8652-91E6-AE8E47032E16",
    "key": "bullseye-lantern",
    "label": "Bullseye Lantern",
    "state": "lit",
    "itemId": "357C2F4C-E267-9829-7813-CF93B217433A",
    "boundsM": [
      0.23000000417232513,
      0.47599998116493225,
      0.23089678585529327
    ],
    "runtime": {
      "kind": "glb",
      "url": "https://cdn.fatetide.com/assets/meshes/78dcbbd418b92f42ca65ee986baef61fab78755e083d592f1f65fb81333f8133.glb",
      "sha256": "78dcbbd418b92f42ca65ee986baef61fab78755e083d592f1f65fb81333f8133",
      "bytes": 373008
    }
  },
  {
    "id": "26A01A8F-E137-88FC-3B5F-BEDD40A034F7",
    "key": "bullseye-lantern",
    "label": "Bullseye Lantern",
    "state": "unlit",
    "itemId": "357C2F4C-E267-9829-7813-CF93B217433A",
    "boundsM": [
      0.23000000417232513,
      0.47599998116493225,
      0.23089678585529327
    ],
    "runtime": {
      "kind": "glb",
      "url": "https://cdn.fatetide.com/assets/meshes/943e482168a4de16be99f9aef9267b5468e9e5a31135ad5e119af17ca4602d31.glb",
      "sha256": "943e482168a4de16be99f9aef9267b5468e9e5a31135ad5e119af17ca4602d31",
      "bytes": 354352
    }
  },
  {
    "id": "D74F0851-1A7F-D464-994D-FCA1CACF77FF",
    "key": "campfire",
    "label": "Campfire",
    "state": "lit",
    "itemId": "1A46B638-6795-4576-A614-2C402EA5DE38",
    "boundsM": [
      1.0830076932907104,
      0.5750460028648376,
      1.0596047639846802
    ],
    "runtime": {
      "kind": "glb",
      "url": "https://cdn.fatetide.com/assets/meshes/2eea82e4b89ba9e6de0c195c7d9747056372dae89c903a6c8b49fdab55357dde.glb",
      "sha256": "2eea82e4b89ba9e6de0c195c7d9747056372dae89c903a6c8b49fdab55357dde",
      "bytes": 818084
    }
  },
  {
    "id": "3816E733-CB5E-DDBE-B67F-AC2AD8481571",
    "key": "campfire",
    "label": "Campfire",
    "state": "unlit",
    "itemId": "1A46B638-6795-4576-A614-2C402EA5DE38",
    "boundsM": [
      1.0830076932907104,
      0.2532307505607605,
      1.0596047639846802
    ],
    "runtime": {
      "kind": "glb",
      "url": "https://cdn.fatetide.com/assets/meshes/47a404e1c46e96fd2924fc81977861a1679f6a1a7eb83e9f6ac1b5cfc3ca83a7.glb",
      "sha256": "47a404e1c46e96fd2924fc81977861a1679f6a1a7eb83e9f6ac1b5cfc3ca83a7",
      "bytes": 681628
    }
  },
  {
    "id": "BAD4B91D-8970-05E2-6B02-D7B1EACE2E63",
    "key": "continual-lantern",
    "label": "Continual Flame Lantern",
    "state": "lit",
    "itemId": "212F2A24-3F66-AC79-DB6A-F97487DA9680",
    "boundsM": [
      0.23000000417232513,
      0.47599998116493225,
      0.23000000417232513
    ],
    "runtime": {
      "kind": "glb",
      "url": "https://cdn.fatetide.com/assets/meshes/e83635f88000fd31ef8226906f3af811076e03a327c07b367dee020d700c8326.glb",
      "sha256": "e83635f88000fd31ef8226906f3af811076e03a327c07b367dee020d700c8326",
      "bytes": 123860
    }
  },
  {
    "id": "2F16049C-B8B4-184E-3F1A-DD8413548254",
    "key": "continual-lantern",
    "label": "Continual Flame Lantern",
    "state": "unlit",
    "itemId": "212F2A24-3F66-AC79-DB6A-F97487DA9680",
    "boundsM": [
      0.23000000417232513,
      0.47599998116493225,
      0.23000000417232513
    ],
    "runtime": {
      "kind": "glb",
      "url": "https://cdn.fatetide.com/assets/meshes/a72dad32fe2fe33ab57dbed373d950be804ede4b2688ca37a4d443cb4c3ffb9a.glb",
      "sha256": "a72dad32fe2fe33ab57dbed373d950be804ede4b2688ca37a4d443cb4c3ffb9a",
      "bytes": 105220
    }
  },
  {
    "id": "38BF86C2-B4EF-BA6B-B752-7EAE303FDBF1",
    "key": "glowing-fungus",
    "label": "Glowing Fungus Cluster",
    "state": "lit",
    "itemId": "B472D7B8-7535-89E1-82C1-8FDAE2BD8CBC",
    "boundsM": [
      0.25298354029655457,
      0.31321173906326294,
      0.315097451210022
    ],
    "runtime": {
      "kind": "glb",
      "url": "https://cdn.fatetide.com/assets/meshes/55cc3c40c1ee538d8c58d33eae6cf10ec97b97c9645e82533a13afaeae5b2663.glb",
      "sha256": "55cc3c40c1ee538d8c58d33eae6cf10ec97b97c9645e82533a13afaeae5b2663",
      "bytes": 269644
    }
  },
  {
    "id": "9A37399E-D758-4A85-3BD6-5DB67830A29E",
    "key": "glowing-fungus",
    "label": "Glowing Fungus Cluster",
    "state": "unlit",
    "itemId": "B472D7B8-7535-89E1-82C1-8FDAE2BD8CBC",
    "boundsM": [
      0.25298354029655457,
      0.31321173906326294,
      0.315097451210022
    ],
    "runtime": {
      "kind": "glb",
      "url": "https://cdn.fatetide.com/assets/meshes/e7a5869b39ef7efb2b6121502670a5a96c131e39d66447146c35eea62889b580.glb",
      "sha256": "e7a5869b39ef7efb2b6121502670a5a96c131e39d66447146c35eea62889b580",
      "bytes": 269444
    }
  },
  {
    "id": "6746418D-B878-712C-E16C-ABBB38A416C6",
    "key": "hooded-lantern",
    "label": "Hooded Lantern",
    "state": "lit",
    "itemId": "1ED8C7F6-6E09-40F7-6F53-562D0B45FF02",
    "boundsM": [
      0.23000000417232513,
      0.47599998116493225,
      0.23000000417232513
    ],
    "runtime": {
      "kind": "glb",
      "url": "https://cdn.fatetide.com/assets/meshes/fb6bd0ed426ea32e04077a677a42331db7f4a26e0997a54a6b669d87798fc284.glb",
      "sha256": "fb6bd0ed426ea32e04077a677a42331db7f4a26e0997a54a6b669d87798fc284",
      "bytes": 315880
    }
  },
  {
    "id": "D28DD126-7854-35AB-6121-857730833BE2",
    "key": "hooded-lantern",
    "label": "Hooded Lantern",
    "state": "unlit",
    "itemId": "1ED8C7F6-6E09-40F7-6F53-562D0B45FF02",
    "boundsM": [
      0.23000000417232513,
      0.47599998116493225,
      0.23000000417232513
    ],
    "runtime": {
      "kind": "glb",
      "url": "https://cdn.fatetide.com/assets/meshes/e389034d78d63acbf81fee2b94dcf41eaa9007f525cd33ee5c19aa9c07556704.glb",
      "sha256": "e389034d78d63acbf81fee2b94dcf41eaa9007f525cd33ee5c19aa9c07556704",
      "bytes": 297228
    }
  },
  {
    "id": "3D20F5B5-188C-1936-4552-86116CD8E5DD",
    "key": "torch",
    "label": "Torch",
    "state": "lit",
    "itemId": "43FDAF91-4AC8-A033-D914-BD640A810046",
    "boundsM": [
      0.12362617254257202,
      1.184999942779541,
      0.12200000137090683
    ],
    "runtime": {
      "kind": "glb",
      "url": "https://cdn.fatetide.com/assets/meshes/0ff80f90b2531853530bf4527d3b05559a8ef46ea00563223beec70cfb7495ea.glb",
      "sha256": "0ff80f90b2531853530bf4527d3b05559a8ef46ea00563223beec70cfb7495ea",
      "bytes": 307744
    }
  },
  {
    "id": "50A70EDA-481A-1A04-A661-3FA95738B815",
    "key": "torch",
    "label": "Torch",
    "state": "unlit",
    "itemId": "43FDAF91-4AC8-A033-D914-BD640A810046",
    "boundsM": [
      0.09799999743700027,
      0.9191507697105408,
      0.09799999743700027
    ],
    "runtime": {
      "kind": "glb",
      "url": "https://cdn.fatetide.com/assets/meshes/2cc3f223a1f9e9a00123633bd93fbfc852e9852436a3ddb66c30d8b9f6c41b34.glb",
      "sha256": "2cc3f223a1f9e9a00123633bd93fbfc852e9852436a3ddb66c30d8b9f6c41b34",
      "bytes": 289012
    }
  },
  {
    "id": "9855410D-1800-C297-966E-287AF333B24A",
    "key": "iron-brazier",
    "label": "Brazier, Iron",
    "state": "lit",
    "itemId": "4CA7635F-88DC-477F-9413-7FC015DE07BD",
    "boundsM": [
      0.8600000143051147,
      1.3650000095367432,
      0.8600000143051147
    ],
    "runtime": {
      "kind": "glb",
      "url": "https://cdn.fatetide.com/assets/meshes/a2eed86bb8d5d739fe9f80466ef92c08414f69cdc3734158da032a43ff17867b.glb",
      "sha256": "a2eed86bb8d5d739fe9f80466ef92c08414f69cdc3734158da032a43ff17867b",
      "bytes": 634096
    }
  },
  {
    "id": "169CE891-2271-7A0A-844E-4773B1CAA95A",
    "key": "iron-brazier",
    "label": "Brazier, Iron",
    "state": "unlit",
    "itemId": "4CA7635F-88DC-477F-9413-7FC015DE07BD",
    "boundsM": [
      0.8600000143051147,
      1.0750000476837158,
      0.8600000143051147
    ],
    "runtime": {
      "kind": "glb",
      "url": "https://cdn.fatetide.com/assets/meshes/58c16cdc09d67a1a837eb6911dcc1b2b145ea8ed3ec07d759706fa8815e63f80.glb",
      "sha256": "58c16cdc09d67a1a837eb6911dcc1b2b145ea8ed3ec07d759706fa8815e63f80",
      "bytes": 438124
    }
  },
  {
    "id": "FEF28243-B4B3-7238-6E57-D530B3A7EFD7",
    "key": "copper-brazier",
    "label": "Brazier, Copper",
    "state": "lit",
    "itemId": "69AE91B6-07B7-CC2B-05E4-0164FD2C4B97",
    "boundsM": [
      0.8600000143051147,
      1.3650000095367432,
      0.8600000143051147
    ],
    "runtime": {
      "kind": "glb",
      "url": "https://cdn.fatetide.com/assets/meshes/25f42bce005e05bafff03f23c137ca630f4585aaf98b816c612a155b98557c0b.glb",
      "sha256": "25f42bce005e05bafff03f23c137ca630f4585aaf98b816c612a155b98557c0b",
      "bytes": 441856
    }
  },
  {
    "id": "6DB2EEB8-7E86-262B-9070-01228E78017D",
    "key": "copper-brazier",
    "label": "Brazier, Copper",
    "state": "unlit",
    "itemId": "69AE91B6-07B7-CC2B-05E4-0164FD2C4B97",
    "boundsM": [
      0.8600000143051147,
      1.0750000476837158,
      0.8600000143051147
    ],
    "runtime": {
      "kind": "glb",
      "url": "https://cdn.fatetide.com/assets/meshes/ec42e1b7d163aa2ec97673ce6952d40122a3b34c01bc8e6c75fc72109425be8a.glb",
      "sha256": "ec42e1b7d163aa2ec97673ce6952d40122a3b34c01bc8e6c75fc72109425be8a",
      "bytes": 245884
    }
  },
  {
    "id": "B16FA3C2-9C32-063F-C7D2-F37F01678D1C",
    "key": "dragon-brazier",
    "label": "Dragonfire Brazier",
    "state": "lit",
    "itemId": "3FAC8B32-E900-54A6-AAF7-B41EAB62B688",
    "boundsM": [
      0.8880000114440918,
      1.3650000095367432,
      0.8600000143051147
    ],
    "runtime": {
      "kind": "glb",
      "url": "https://cdn.fatetide.com/assets/meshes/429f9428acadbd61054f006a12f12df9fabac67e481b16a062e257956412855d.glb",
      "sha256": "429f9428acadbd61054f006a12f12df9fabac67e481b16a062e257956412855d",
      "bytes": 1803292
    }
  },
  {
    "id": "499266E9-5844-6FB5-0A81-BCB8864D484C",
    "key": "dragon-brazier",
    "label": "Dragonfire Brazier",
    "state": "unlit",
    "itemId": "3FAC8B32-E900-54A6-AAF7-B41EAB62B688",
    "boundsM": [
      0.8880000114440918,
      1.0750000476837158,
      0.8600000143051147
    ],
    "runtime": {
      "kind": "glb",
      "url": "https://cdn.fatetide.com/assets/meshes/23e796d3624dbf9c804c4436f11c431ac32ce0cce10544d3df7406ffa85ab7d3.glb",
      "sha256": "23e796d3624dbf9c804c4436f11c431ac32ce0cce10544d3df7406ffa85ab7d3",
      "bytes": 1607300
    }
  },
  {
    "id": "0CEEA51E-4D02-8C37-BB5C-BD263D616B7A",
    "key": "fireplace",
    "label": "Fireplace, Medium",
    "state": "lit",
    "itemId": "9958B743-AB48-F5B3-27D7-726E2374B293",
    "boundsM": [
      1.4399999380111694,
      1.0899999141693115,
      0.6999999284744263
    ],
    "runtime": {
      "kind": "glb",
      "url": "https://cdn.fatetide.com/assets/meshes/e4d9883622a0555178227be74b618dce7ff0e96a597b0df2075b561bcbcb8296.glb",
      "sha256": "e4d9883622a0555178227be74b618dce7ff0e96a597b0df2075b561bcbcb8296",
      "bytes": 1597792
    }
  },
  {
    "id": "5B1A2FFB-F745-6C2D-06E8-A1FAC6DA1971",
    "key": "fireplace",
    "label": "Fireplace, Medium",
    "state": "unlit",
    "itemId": "9958B743-AB48-F5B3-27D7-726E2374B293",
    "boundsM": [
      1.4399999380111694,
      1.0899999141693115,
      0.6999999284744263
    ],
    "runtime": {
      "kind": "glb",
      "url": "https://cdn.fatetide.com/assets/meshes/a42b312ff30d630d8361c3009ce13a98b31bbe3fdb7c985b7c54bcbd2d82c883.glb",
      "sha256": "a42b312ff30d630d8361c3009ce13a98b31bbe3fdb7c985b7c54bcbd2d82c883",
      "bytes": 1524356
    }
  },
  {
    "id": "519EFB89-9AFC-CB37-50AC-53C5762FB5FB",
    "key": "candelabra",
    "label": "Candleabra",
    "state": "lit",
    "itemId": "09DE1084-29E1-7D19-D0A1-3FEC28D6EA06",
    "boundsM": [
      0.6700000166893005,
      0.7680000066757202,
      0.30000001192092896
    ],
    "runtime": {
      "kind": "glb",
      "url": "https://cdn.fatetide.com/assets/meshes/3af5268140168e42d4f03309453daa8ad9974ca1261164642552b16dda486007.glb",
      "sha256": "3af5268140168e42d4f03309453daa8ad9974ca1261164642552b16dda486007",
      "bytes": 3166700
    }
  },
  {
    "id": "E9F187CD-CB57-42F2-0DF8-9A2080906963",
    "key": "candelabra",
    "label": "Candleabra",
    "state": "unlit",
    "itemId": "09DE1084-29E1-7D19-D0A1-3FEC28D6EA06",
    "boundsM": [
      0.6700000166893005,
      0.7129999995231628,
      0.30000001192092896
    ],
    "runtime": {
      "kind": "glb",
      "url": "https://cdn.fatetide.com/assets/meshes/ca9ee6bcc3a516c4dcf8c05c3f8b2af1d3f8e3ece8b6eeaf09d18ba539b456bc.glb",
      "sha256": "ca9ee6bcc3a516c4dcf8c05c3f8b2af1d3f8e3ece8b6eeaf09d18ba539b456bc",
      "bytes": 3086456
    }
  },
  {
    "id": "6FC5DE25-8091-B8BD-F34C-9AE1F537AA2E",
    "key": "candle-chandelier",
    "label": "Candle Chandelier",
    "state": "lit",
    "itemId": "F3D1E370-A18A-0141-4707-13204C59BD53",
    "boundsM": [
      3.608349561691284,
      3.689870595932007,
      3.6083970069885254
    ],
    "runtime": {
      "kind": "glb",
      "url": "https://cdn.fatetide.com/assets/meshes/a4ad89755efefad1133def17c246f6e8fd18356a232d04bd0261beb4866d0e27.glb",
      "sha256": "a4ad89755efefad1133def17c246f6e8fd18356a232d04bd0261beb4866d0e27",
      "bytes": 5159208
    }
  },
  {
    "id": "614E2FD9-95C2-CD7E-F57D-1B5C3ADF24F9",
    "key": "candle-chandelier",
    "label": "Candle Chandelier",
    "state": "unlit",
    "itemId": "F3D1E370-A18A-0141-4707-13204C59BD53",
    "boundsM": [
      3.608349561691284,
      3.689870595932007,
      3.6083970069885254
    ],
    "runtime": {
      "kind": "glb",
      "url": "https://cdn.fatetide.com/assets/meshes/9cd30b461ba897761010b6df0b31c8fcfe8896b23815c39bf3ba1dcdfa331a7f.glb",
      "sha256": "9cd30b461ba897761010b6df0b31c8fcfe8896b23815c39bf3ba1dcdfa331a7f",
      "bytes": 4973576
    }
  },
  {
    "id": "217B8C4D-670D-4E02-42EE-C6C26F0729AD",
    "key": "candle",
    "label": "Candle",
    "state": "lit",
    "itemId": "080A899B-48D3-26D5-8DC0-5CEB0CDB320C",
    "boundsM": [
      0.05000000074505806,
      0.18000000715255737,
      0.05000000074505806
    ],
    "runtime": {
      "kind": "glb",
      "url": "https://cdn.fatetide.com/assets/meshes/c0a6dea6c8387703596d41422c27c9a64ad88d0bd2d79701c5a6845f97013b73.glb",
      "sha256": "c0a6dea6c8387703596d41422c27c9a64ad88d0bd2d79701c5a6845f97013b73",
      "bytes": 1581140
    }
  },
  {
    "id": "CC91ECE3-743B-B785-59E5-A16DFE5AEB71",
    "key": "candle",
    "label": "Candle",
    "state": "unlit",
    "itemId": "080A899B-48D3-26D5-8DC0-5CEB0CDB320C",
    "boundsM": [
      0.05000000074505806,
      0.125,
      0.05000000074505806
    ],
    "runtime": {
      "kind": "glb",
      "url": "https://cdn.fatetide.com/assets/meshes/bd3b2e345e8a62304853b3f3b6d5b9a4f27b97dc7ba9ba88a6f7415068990356.glb",
      "sha256": "bd3b2e345e8a62304853b3f3b6d5b9a4f27b97dc7ba9ba88a6f7415068990356",
      "bytes": 1562184
    }
  },
  {
    "id": "E5B4AD7B-FA73-59AA-C9A6-245B2177C7B1",
    "key": "glass-chandelier",
    "label": "Glass Chandelier",
    "state": "lit",
    "itemId": "7B0F9E3A-D110-8CD7-D685-E7685FE4FE96",
    "boundsM": [
      3.608349561691284,
      3.689870595932007,
      3.6083970069885254
    ],
    "runtime": {
      "kind": "glb",
      "url": "https://cdn.fatetide.com/assets/meshes/014a3e6f0042da78f10bd7c58b0fa1e9de92a9c57c33a0aa96926af2e47fc84e.glb",
      "sha256": "014a3e6f0042da78f10bd7c58b0fa1e9de92a9c57c33a0aa96926af2e47fc84e",
      "bytes": 5258300
    }
  },
  {
    "id": "0315879F-A853-C5D7-5DB0-54690DBFBDF3",
    "key": "glass-chandelier",
    "label": "Glass Chandelier",
    "state": "unlit",
    "itemId": "7B0F9E3A-D110-8CD7-D685-E7685FE4FE96",
    "boundsM": [
      3.608349561691284,
      3.689870595932007,
      3.6083970069885254
    ],
    "runtime": {
      "kind": "glb",
      "url": "https://cdn.fatetide.com/assets/meshes/34f212ea7eedee50df02aa159374fe7ee4af9101ff5c130f269aebf1197a12dd.glb",
      "sha256": "34f212ea7eedee50df02aa159374fe7ee4af9101ff5c130f269aebf1197a12dd",
      "bytes": 5072660
    }
  },
  {
    "id": "99F6FAFF-4285-D800-45A2-A78E454D1551",
    "key": "invocation-candle",
    "label": "Candle of Invocation",
    "state": "lit",
    "itemId": "26043E77-7C2D-A5C5-46D0-7BC3E7B645D8",
    "boundsM": [
      0.06960000097751617,
      0.4000000059604645,
      0.06960000097751617
    ],
    "runtime": {
      "kind": "glb",
      "url": "https://cdn.fatetide.com/assets/meshes/6c537927581f1fd72ddec5e4e7d9c52f73a9d2816ea7266ae703e5cadd46fa50.glb",
      "sha256": "6c537927581f1fd72ddec5e4e7d9c52f73a9d2816ea7266ae703e5cadd46fa50",
      "bytes": 1669220
    }
  },
  {
    "id": "A1C6248F-1975-43DF-BA61-2D3799CB54BE",
    "key": "invocation-candle",
    "label": "Candle of Invocation",
    "state": "unlit",
    "itemId": "26043E77-7C2D-A5C5-46D0-7BC3E7B645D8",
    "boundsM": [
      0.06960000097751617,
      0.3449999988079071,
      0.06960000097751617
    ],
    "runtime": {
      "kind": "glb",
      "url": "https://cdn.fatetide.com/assets/meshes/471ad030698cd91b39af56c05f2761231a5641dd022d53ebc46dc3849fcdf030.glb",
      "sha256": "471ad030698cd91b39af56c05f2761231a5641dd022d53ebc46dc3849fcdf030",
      "bytes": 1650640
    }
  },
  {
    "id": "35F113D7-7335-1752-B70A-7336C0616E05",
    "key": "pillar-candle",
    "label": "Pillar Candle",
    "state": "lit",
    "itemId": "83EBCE1D-8707-13EE-7D92-3DD7961CC247",
    "boundsM": [
      0.10400000214576721,
      0.2800000011920929,
      0.10399999469518661
    ],
    "runtime": {
      "kind": "glb",
      "url": "https://cdn.fatetide.com/assets/meshes/e582caec865650b596c5325e525412d3f985261b03cc4a2ee4185db1aaf0d388.glb",
      "sha256": "e582caec865650b596c5325e525412d3f985261b03cc4a2ee4185db1aaf0d388",
      "bytes": 1580576
    }
  },
  {
    "id": "59C6CFEA-80F8-86C5-C2FB-EB6B79AC2BA2",
    "key": "pillar-candle",
    "label": "Pillar Candle",
    "state": "unlit",
    "itemId": "83EBCE1D-8707-13EE-7D92-3DD7961CC247",
    "boundsM": [
      0.10400000214576721,
      0.22499999403953552,
      0.10399999469518661
    ],
    "runtime": {
      "kind": "glb",
      "url": "https://cdn.fatetide.com/assets/meshes/7fa17135eec010e68f7aadd4e2755ce3fd70ee69f0d6db3268368b5b94965bfb.glb",
      "sha256": "7fa17135eec010e68f7aadd4e2755ce3fd70ee69f0d6db3268368b5b94965bfb",
      "bytes": 1562200
    }
  },
  {
    "id": "1E39ED0F-F067-FF1C-80D8-688143E3C187",
    "key": "taper-candle",
    "label": "Taper Candle",
    "state": "lit",
    "itemId": "F7162A9B-F087-49D8-BD34-749FB6BACAAA",
    "boundsM": [
      0.03716199845075607,
      0.36000001430511475,
      0.035999998450279236
    ],
    "runtime": {
      "kind": "glb",
      "url": "https://cdn.fatetide.com/assets/meshes/273728c3e4fde97cd8e958b9d5fc5ff2d5a5c90b0e346e68588d601fc715c848.glb",
      "sha256": "273728c3e4fde97cd8e958b9d5fc5ff2d5a5c90b0e346e68588d601fc715c848",
      "bytes": 1601028
    }
  },
  {
    "id": "BD8DD507-4921-76B9-91BA-EDC9DD23E224",
    "key": "taper-candle",
    "label": "Taper Candle",
    "state": "unlit",
    "itemId": "F7162A9B-F087-49D8-BD34-749FB6BACAAA",
    "boundsM": [
      0.035999998450279236,
      0.3050000071525574,
      0.035999998450279236
    ],
    "runtime": {
      "kind": "glb",
      "url": "https://cdn.fatetide.com/assets/meshes/32a9e87ffd0c3702ac3c5c39ec514e09dbd523319db7929975a1c495defaeea4.glb",
      "sha256": "32a9e87ffd0c3702ac3c5c39ec514e09dbd523319db7929975a1c495defaeea4",
      "bytes": 1582172
    }
  },
  {
    "id": "2F0C68DC-4877-C603-C400-9DB9F2B56D1F",
    "key": "moonfire-hearth",
    "label": "Glyph-Etched Moonfire Hearth",
    "state": "unlit",
    "itemId": "9958B743-AB48-F5B3-27D7-726E2374B293",
    "boundsM": [
      1.44,
      1.09,
      0.7
    ],
    "runtime": {
      "kind": "glb",
      "url": "https://cdn.fatetide.com/assets/meshes/4f796cbf780e0e1bb21d8f232b93786533683f238a39f3c243b07a97ab999e9a.glb",
      "sha256": "4f796cbf780e0e1bb21d8f232b93786533683f238a39f3c243b07a97ab999e9a",
      "bytes": 3940324
    }
  },
  {
    "id": "0912EB2E-3914-C412-BFEE-F3F3FC0FA0CF",
    "key": "moonfire-hearth",
    "label": "Glyph-Etched Moonfire Hearth",
    "state": "lit",
    "itemId": "9958B743-AB48-F5B3-27D7-726E2374B293",
    "boundsM": [
      1.44,
      1.09,
      0.7
    ],
    "runtime": {
      "kind": "glb",
      "url": "https://cdn.fatetide.com/assets/meshes/65ca9a43631b96d0f901d5aca4846fc6bd449756ee8f867ca5321f8724049627.glb",
      "sha256": "65ca9a43631b96d0f901d5aca4846fc6bd449756ee8f867ca5321f8724049627",
      "bytes": 4019976
    }
  },
];
